const styles = (theme) => ({
  grow: {
    flexGrow: 1,
  },
  paper: {
    zIndex: 100,
    paddingBottom: theme.mixins.toolbar.minHeight,
    border: 'none',
    width: '100%',
  },
  categoryArrow: {
    opacity: '54%',
    transform: 'rotate(180deg)',
  },
  menuText: {
    fontSize: '1.25rem',
    fontWeight: 300,
  },
  userText: {
    fontSize: '1.25rem',
    fontWeight: 300,
    marginLeft: theme.spacing(1),
    textTransform: 'capitalize',
  },
  user: {
    margin: theme.spacing(2, 1),
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  badge: {
    backgroundColor: theme.color.green,
    border: `2px solid ${theme.color.white}`,
    height: 10,
    width: 10,
  },
  help: {
    padding: theme.spacing(3, 2),
    textTransform: 'none',
    color: theme.color.grey_dark,
    fontSize: 16,
    width: 'auto',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& svg': {
      '& path': {
        fill: theme.color.grey_dark,
      },
    },
  },
  helpIcon: {
    height: 20,
    width: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.color.grey_dark}`,
    borderRadius: '50%',
    '&::after': {
      fontSize: 16,
      content: '"?"',
    },
  },
  quantity: {
    color: theme.color.green,
    margin: '-5px 8px 0 0',
  },
  avatarIconStyle: {
    backgroundColor: 'unset',
    marginRight: 8,
  },

  avatarUserInitials: {
    textTransform: 'uppercase',
    color: theme.color.grey_dark,
  },
});

export default styles;
